import { jsxs as i, jsx as a } from "react/jsx-runtime";
import { Fragment as m } from "react";
import { Container as h } from "@intergamma/container";
function g({
  t: l,
  lang: e
}) {
  return e === "fr-BE" ? /* @__PURE__ */ i("a", { href: l("DiscoverTheAppUrl"), children: [
    /* @__PURE__ */ i(
      "svg",
      {
        className: "block cursor-pointer",
        height: "24",
        viewBox: "0 0 97 28",
        fill: "none",
        children: [
          /* @__PURE__ */ a(
            "path",
            {
              d: "M18.176 3.6H20.468C23.348 3.6 24.368 5.724 24.368 7.8C24.368 9.732 23.468 12 20.42 12H18.176V3.6ZM20.552 11.028C22.64 11.028 23.288 9.324 23.288 7.8C23.288 6.168 22.532 4.56 20.684 4.56H19.22V11.028H20.552ZM27.1837 5.088L28.8877 3.216H30.3757L28.2397 5.088H27.1837ZM28.5397 12.144C26.8597 12.144 25.8157 10.8 25.8157 8.928C25.8157 6.9 26.9077 5.724 28.5397 5.724C29.9197 5.724 31.0717 6.624 31.0717 8.64C31.0717 8.832 31.0597 9.096 31.0357 9.336H26.8837C26.9677 10.464 27.6397 11.196 28.5637 11.196C29.0317 11.196 29.4997 11.028 29.8837 10.644L30.5197 11.352C30.0637 11.808 29.3677 12.144 28.5397 12.144ZM26.8717 8.448H30.0157C30.0037 7.056 29.1877 6.648 28.5397 6.648C27.6517 6.648 26.9317 7.188 26.8717 8.448ZM34.8167 12.144C33.2567 12.144 32.2727 10.968 32.2727 8.94C32.2727 6.924 33.2567 5.724 34.8647 5.724C35.8847 5.724 36.6647 6.192 37.0127 7.152L36.0287 7.512C35.8487 7.044 35.4767 6.696 34.8767 6.696C33.8327 6.696 33.3407 7.56 33.3407 8.94C33.3407 10.332 33.8567 11.16 34.8407 11.16C35.4527 11.16 35.9087 10.824 36.0887 10.248L37.0607 10.572C36.7607 11.58 35.9447 12.144 34.8167 12.144ZM40.9847 12.144C39.3407 12.144 38.2727 10.968 38.2727 8.94C38.2727 6.924 39.3407 5.724 40.9847 5.724C42.6287 5.724 43.6967 6.9 43.6967 8.928C43.6967 10.944 42.6287 12.144 40.9847 12.144ZM40.9847 11.172C42.0167 11.172 42.6407 10.332 42.6407 8.928C42.6407 7.536 42.0287 6.684 40.9847 6.684C39.9407 6.684 39.3287 7.512 39.3287 8.94C39.3287 10.332 39.9407 11.172 40.9847 11.172ZM49.0441 12V11.412C48.6361 11.94 48.1441 12.144 47.4961 12.144C46.0561 12.144 45.2641 11.376 45.2641 9.408V5.868H46.3081V9.564C46.3081 10.728 46.8721 11.172 47.6281 11.172C48.4321 11.172 49.0441 10.788 49.0441 9.588V5.868H50.0881V12H49.0441ZM53.7298 12L51.4858 5.868H52.5418L53.9938 9.96C54.0658 10.176 54.1258 10.344 54.1858 10.56C54.2458 10.344 54.3058 10.176 54.3778 9.96L55.8058 5.868H56.8498L54.6058 12H53.7298ZM58.2265 12V5.868H59.2705V6.672C59.5465 6.06 60.0385 5.724 60.7225 5.724C61.1185 5.724 61.4545 5.856 61.6705 6.036L61.5145 7.02C61.3225 6.888 61.0585 6.756 60.6385 6.756C60.0505 6.756 59.2705 7.152 59.2705 8.544V12H58.2265ZM65.2545 12.144C63.5745 12.144 62.5305 10.8 62.5305 8.928C62.5305 6.9 63.6225 5.724 65.2545 5.724C66.6345 5.724 67.7865 6.624 67.7865 8.64C67.7865 8.832 67.7745 9.096 67.7505 9.336H63.5985C63.6825 10.464 64.3545 11.196 65.2785 11.196C65.7465 11.196 66.2145 11.028 66.5985 10.644L67.2345 11.352C66.7785 11.808 66.0825 12.144 65.2545 12.144ZM63.5865 8.448H66.7305C66.7185 7.056 65.9025 6.648 65.2545 6.648C64.3665 6.648 63.6465 7.188 63.5865 8.448ZM69.1076 12V11.232L72.2996 6.792H69.3476V5.868H73.6076V6.612L70.4036 11.064H73.5956V12H69.1076Z",
              fill: "#003878"
            }
          ),
          /* @__PURE__ */ a(
            "path",
            {
              d: "M17.96 24V15.996L19.364 15.336V24H17.96ZM20.7841 18.468C21.0001 18.276 21.4441 17.748 21.5401 17.292C21.1441 17.208 20.7961 16.896 20.7961 16.404C20.7961 15.828 21.2521 15.456 21.7441 15.456C22.2841 15.456 22.7281 15.84 22.7281 16.572C22.7281 17.496 22.0921 18.408 21.3481 18.864L20.7841 18.468ZM27.31 24V23.508C27.01 23.82 26.494 24.144 25.678 24.144C24.418 24.144 23.458 23.448 23.458 22.104C23.458 20.688 24.646 20.076 25.858 20.076C26.434 20.076 26.926 20.184 27.31 20.4V20.076C27.31 19.272 26.914 18.96 26.11 18.96C25.366 18.96 24.802 19.176 24.286 19.536L23.854 18.396C24.406 18.024 25.222 17.724 26.254 17.724C27.334 17.724 28.678 17.988 28.678 20.052V24H27.31ZM25.942 22.908C26.542 22.908 26.998 22.644 27.31 22.32V21.528C26.986 21.372 26.542 21.276 26.086 21.276C25.39 21.276 24.826 21.516 24.826 22.104C24.826 22.584 25.21 22.908 25.942 22.908ZM33.153 24.144C32.493 24.144 32.049 23.868 31.761 23.508V25.764L30.357 26.412V17.868H31.761V18.336C32.061 17.976 32.505 17.724 33.165 17.724C34.689 17.724 35.685 18.888 35.685 20.94C35.685 22.956 34.641 24.144 33.153 24.144ZM32.949 22.8C33.801 22.8 34.281 22.14 34.281 20.94C34.281 19.824 33.813 19.056 32.949 19.056C32.397 19.056 32.013 19.284 31.761 19.656V22.2C31.977 22.512 32.385 22.8 32.949 22.8ZM39.9851 24.144C39.3251 24.144 38.8811 23.868 38.5931 23.508V25.764L37.1891 26.412V17.868H38.5931V18.336C38.8931 17.976 39.3371 17.724 39.9971 17.724C41.5211 17.724 42.5171 18.888 42.5171 20.94C42.5171 22.956 41.4731 24.144 39.9851 24.144ZM39.7811 22.8C40.6331 22.8 41.1131 22.14 41.1131 20.94C41.1131 19.824 40.6451 19.056 39.7811 19.056C39.2291 19.056 38.8451 19.284 38.5931 19.656V22.2C38.8091 22.512 39.2171 22.8 39.7811 22.8ZM44.0811 24V15.996L45.4851 15.336V24H44.0811ZM48.0692 17.028C47.6012 17.028 47.2292 16.656 47.2292 16.188C47.2292 15.732 47.6012 15.36 48.0692 15.36C48.5372 15.36 48.8972 15.732 48.8972 16.188C48.8972 16.656 48.5372 17.028 48.0692 17.028ZM47.3612 24V17.868H48.7652V24H47.3612ZM57.0173 24.144C54.4253 24.144 53.3333 21.996 53.3333 19.8C53.3333 17.748 54.4973 15.456 57.0173 15.456C58.6373 15.456 59.4053 16.272 59.9573 17.148L58.6733 17.88C58.3013 17.328 57.8093 16.848 57.0173 16.848C55.3253 16.848 54.8213 18.492 54.8213 19.8C54.8213 21.312 55.4573 22.752 57.0173 22.752C57.9533 22.752 58.6373 22.056 58.6373 21.18V21.048H57.1613V19.692H60.1013V20.856C60.1013 22.992 58.7573 24.144 57.0173 24.144ZM67.2292 24L66.5692 22.164H63.2452L62.5852 24H61.0612L64.1932 15.6H65.6212L68.7412 24H67.2292ZM66.1132 20.868L65.1892 18.348C65.0932 18.108 64.9732 17.748 64.9132 17.496C64.8412 17.748 64.7212 18.108 64.6372 18.348L63.7012 20.868H66.1132ZM77.6718 24H76.2318V19.536C76.2318 19.236 76.2558 18.756 76.2798 18.528C76.1718 18.852 76.0158 19.26 75.8958 19.56L73.8558 24.144L71.8158 19.536C71.6838 19.248 71.5278 18.852 71.4198 18.528C71.4438 18.756 71.4678 19.236 71.4678 19.536V24H70.0278V15.6H71.4798L73.6398 20.532C73.7238 20.736 73.8078 20.964 73.8678 21.156C73.9278 20.964 74.0118 20.736 74.0958 20.532L76.2678 15.6H77.6718V24ZM87.3515 24H85.9115V19.536C85.9115 19.236 85.9355 18.756 85.9595 18.528C85.8515 18.852 85.6955 19.26 85.5755 19.56L83.5355 24.144L81.4955 19.536C81.3635 19.248 81.2075 18.852 81.0995 18.528C81.1235 18.756 81.1475 19.236 81.1475 19.536V24H79.7075V15.6H81.1595L83.3195 20.532C83.4035 20.736 83.4875 20.964 83.5475 21.156C83.6075 20.964 83.6915 20.736 83.7755 20.532L85.9475 15.6H87.3515V24ZM94.8034 24L94.1434 22.164H90.8194L90.1594 24H88.6354L91.7674 15.6H93.1954L96.3154 24H94.8034ZM93.6874 20.868L92.7634 18.348C92.6674 18.108 92.5474 17.748 92.4874 17.496C92.4154 17.748 92.2954 18.108 92.2114 18.348L91.2754 20.868H93.6874Z",
              fill: "#003878"
            }
          ),
          /* @__PURE__ */ a("rect", { y: "1", width: "14", height: "24", rx: "2", fill: "black" }),
          /* @__PURE__ */ a("rect", { x: "1", y: "2", width: "12", height: "20", rx: "1", fill: "#008cd2" }),
          /* @__PURE__ */ a("rect", { x: "4", y: "23", width: "6", height: "1", rx: "0.5", fill: "#008cd2" })
        ]
      }
    ),
    /* @__PURE__ */ a("span", { className: "sr-only", children: l("DiscoverTheApp") })
  ] }) : e === "nl-BE" ? /* @__PURE__ */ a("a", { href: l("DiscoverTheAppUrl"), children: /* @__PURE__ */ a(
    "img",
    {
      className: "h-6",
      src: "https://images.ctfassets.net/2oqwvxysf41a/1rc0yXKv7s80YxazqWJ6kk/d6f6cfcbf3183f73c3b93fe5d9fbc0bb/thumb_GAMMA_APP.jpg?fm=avif",
      alt: l("DiscoverTheApp"),
      loading: "lazy"
    }
  ) }) : null;
}
function d({
  formula: l,
  ...e
}) {
  return /* @__PURE__ */ i("a", { className: "inline-block align-bottom", ...e, children: [
    /* @__PURE__ */ a("span", { className: "sr-only", children: l.brandName }),
    l.brand === "karwei" ? /* @__PURE__ */ i(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: "104",
        height: "80",
        viewBox: "0 0 104 80",
        focusable: "false",
        className: "h-6 w-[1.937rem] select-none",
        children: [
          /* @__PURE__ */ a("path", { fill: "#010000", d: "M28 40v40h76V0H0v40" }),
          /* @__PURE__ */ a(
            "path",
            {
              fill: "#FFF",
              d: "M35.72 40.933c0 1.09-1.433.802-1.433 1.99 0 .288.063.48.16.8L37.6 55.5 35.498 64h-3.792L28 50.345V40.002h5.905c.7 0 1.815-.095 1.815.93zm.896-8.037c.218.57.39 1.022 1.047 1.334.46.214.737.385.737.97 0 .22-.062.388-.19.514-.294.29-.897.288-1.338.285H28.61c-.733 0-1.647 0-1.647-.93 0-.55.37-.73.726-.92.29-.15.6-.31.6-.67 0-.26-.16-.75-.27-1l-2.01-6-.04-.105c-.18-.57-.387-1.214-.387-1.843 0-.587.273-.966.62-1.444l.114-.16 3.76-5.327c.445-.6.857-1.266.857-2.074 0-.83-.384-1.34-1.28-1.71l-.16-.07c-.446-.19-.8-.338-.8-.87 0-.273.07-.477.215-.62.277-.277.79-.277 1.24-.276h5.61c.866 0 1.646.077 1.646.995 0 .68-.548.89-1.125 1.115-2.065.776-2.925 1.92-4.07 3.484l-.98 1.33 5.36 13.975z"
            }
          ),
          /* @__PURE__ */ a(
            "path",
            {
              fill: "#FFF",
              d: "M23.82 32.553c0 1.12 0 1.353 1.13 1.714.42.13.65.416.65.803 0 .92-1.094.93-1.105.93h-8.99c-.01 0-1.105-.01-1.105-.93 0-.387.23-.673.65-.803 1.13-.36 1.13-.594 1.13-1.714V15.448c0-1.12 0-1.353-1.13-1.715-.42-.13-.65-.416-.65-.803 0-.92 1.095-.93 1.106-.93h8.99c.01 0 1.104.01 1.104.93 0 .386-.23.672-.65.803-1.13.362-1.13.595-1.13 1.715v17.105zm21.98-1.375c-.515 1.965-.07 2.548 1.06 3.045.506.22.917.4.917.987 0 .212-.06.375-.183.498-.295.294-.9.293-1.34.292h-3.737c-.85 0-1.717-.105-1.717-.885 0-.532.273-.64.725-.814.144-.05.308-.12.48-.2.634-.33 1.547-1.04 2.176-3.39l3.81-13.91.81 3.49-3 10.9z"
            }
          ),
          /* @__PURE__ */ a(
            "path",
            {
              fill: "#FFF",
              d: "M48 29.738l.414-1.73h3.948l-3.257-14.336.4-1.672h6.982l4.845 20.605c.155.77.268 1.33 1.11 1.69.48.21.758.428.758.937 0 .188-.056.335-.172.45-.317.32-1.003.32-1.457.318h-8.04c-.74 0-1.5-.1-1.5-.833 0-.48.18-.626.57-.84.85-.49 1.01-.738.71-2.048l-.65-2.55H48zm20.98-14.29c0-1.12 0-1.353-1.13-1.715-.42-.13-.65-.416-.65-.803 0-.92 1.094-.93 1.105-.93h8.316v20.552c0 1.12 0 1.354 1.14 1.715.42.13.65.416.65.803 0 .92-1.09.93-1.1.93h-8.99c-.01 0-1.103-.01-1.103-.93 0-.387.23-.672.65-.803 1.13-.36 1.13-.594 1.13-1.714V15.448zM78.4 12h.464c1.943-.003 3.952-.007 5.73.848 2.09 1.026 3.168 2.75 3.2 5.127.055 3.134-1.705 5.012-5.54 5.91l-.053.013v.18l.06.007c2.84.413 5.48 1.246 5.54 4.52v2.922c-.01.244-.02.58.14.746.07.067.15.1.26.1.263 0 .42-.2.59-.415.19-.246.39-.5.776-.5.39 0 .853.46.853.847 0 .91-1.056 2.06-1.72 2.57-.964.79-2.024 1.125-3.55 1.125-1.5 0-2.657-.428-3.54-1.308-1.04-1.064-1.25-2.356-1.25-3.97v-2.15c0-1.387.06-3.28-1.94-3.477V23.35c1.85-.172 1.94-1.37 1.94-2.814v-3.828c0-1.534-.253-2.35-1.94-2.956v-1.75zM64 40v24h-8.473c-.012 0-1.127-.01-1.127-.93 0-.387.235-.672.662-.803 1.152-.362 1.152-.595 1.15-1.715V43.447c.002-1.12.002-1.353-1.15-1.713-.427-.132-.662-.417-.662-.805 0-.92 1.115-.93 1.127-.93H64zm1.6 0h7.2v6.495c0 .263-.123.705-.95.705-.523 0-.664-.302-.82-.76-.89-2.728-2.625-4.25-5.43-4.688V40zm5.42 17.725l.042-.09c.2-.43.39-.835.88-.835.28 0 .492.074.636.22.237.24.224.62.22.744V64H65.6v-1.682c2.55-.31 4.54-2.026 5.42-4.593zm-3.16-10.322c.16-.547.345-1.003.963-1.003.23 0 .412.066.538.197.27.28.25.793.24 1.04v7.126c.01.247.04.76-.23 1.04-.12.13-.3.197-.53.197-.62 0-.803-.456-.965-1.007-.383-1.603-1.11-2.55-2.26-2.85v-1.888c1.15-.298 1.877-1.245 2.26-2.852zm19.96 13.15c0 1.12 0 1.352 1.13 1.713.42.132.65.417.65.804 0 .92-1.094.93-1.106.93h-8.99c-.01 0-1.104-.01-1.104-.93 0-.387.23-.672.65-.803 1.13-.362 1.13-.595 1.13-1.715V43.447c0-1.12 0-1.353-1.13-1.713-.42-.132-.65-.417-.65-.805 0-.92 1.094-.93 1.105-.93h8.99c.01 0 1.105.01 1.105.93 0 .38-.23.67-.65.8-1.13.36-1.13.59-1.13 1.71v17.11zM41.64 64L37.6 48.496 39.705 40h3.425l4.07 16.052L45.25 64m4.518-19.094L47.836 52.8l-.875-3.37 1.19-4.833.07-.305c.08-.322.15-.626.15-.99 0-.92-.6-1.266-1.14-1.57-.44-.252-.82-.47-.82-.958 0-.52.38-.774 1.15-.774h4.04c.59 0 1.218.062 1.218.805 0 .415-.2.526-.615.717-1.607.706-2.015 1.848-2.416 3.384z"
            }
          )
        ]
      }
    ) : /* @__PURE__ */ i(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: "112",
        height: "40",
        viewBox: "0 0 112 40",
        className: "h-6 w-[4.25rem] select-none",
        children: [
          /* @__PURE__ */ a("path", { fill: "#003978", d: "M0 0h112v40H0z" }),
          /* @__PURE__ */ a(
            "path",
            {
              fill: "#FFF",
              d: "M103 27.9H89c-.68 0-1.25-.57-1.25-1.3v-7.98c0-.72.57-1.3 1.26-1.3h6.4v2.64h-3.8v5.3h6.35v-10.6H91.6V12h10.16c.7 0 1.26.6 1.26 1.32v14.6M82.7 12h-14c-.7 0-1.25.6-1.25 1.32v14.6h3.8V14.64h2.55v5.3h2.54v-5.3h2.54V27.9h5.08V13.33c0-.73-.56-1.32-1.26-1.32m-20.33 0h-14c-.68 0-1.25.6-1.25 1.35v14.6h3.8v-13.3h2.55v5.3H56v-5.3h2.54V27.9h5.08V13.33c0-.73-.57-1.32-1.27-1.32M43.3 27.9h-14c-.7 0-1.25-.57-1.25-1.3v-7.98c0-.72.56-1.3 1.26-1.3h6.4v2.64h-3.8v5.3h6.35v-10.6H31.9V12h10.16c.7 0 1.26.6 1.26 1.32v14.6M16.62 17.3v2.66h3.8v5.3H14.1v-10.6h10.17V12h-14c-.7 0-1.25.6-1.25 1.32V26.6c0 .73.56 1.3 1.26 1.3h13.98V17.3h-7.62"
            }
          )
        ]
      }
    )
  ] });
}
function C({ formula: l, t: e }) {
  if (l.id === "gamma_nl")
    return {
      legal: [
        {
          label: e("ig-legal-footer:PrivacyAndSecurity"),
          href: e("ig-legal-footer:PrivacyAndSecurityUrl")
        },
        {
          label: e("ig-legal-footer:ProductPriceInformation"),
          href: e("ig-legal-footer:ProductPriceInformationUrl")
        }
      ],
      partner: [],
      social: [
        {
          name: "Facebook",
          href: e("ig-legal-footer:FacebookUrl"),
          imageUrl: "//images.ctfassets.net/7k5qhlbm8iou/5CVpZOEfxbYwCrrnEXZUyp/60a1ed1b666a4f3244c863114be19745/facebook_minified.svg"
        },
        {
          name: "Instagram",
          href: e("ig-legal-footer:InstagramUrl"),
          imageUrl: "//images.ctfassets.net/7k5qhlbm8iou/lRrh2n73gAQnh8p16rJeO/69134dd5c63bf0ac606866d4c3789cb0/instagram_minified.svg"
        },
        {
          name: "Pinterest",
          href: e("ig-legal-footer:PinterestUrl"),
          imageUrl: "//images.ctfassets.net/7k5qhlbm8iou/3h09U8JGVyUaMI4BBqxuxA/677c038877b04cee83f805379adc137a/pinterest_dot_com_minified.svg"
        },
        {
          name: "X",
          href: e("ig-legal-footer:TwitterUrl"),
          imageUrl: "//images.ctfassets.net/7k5qhlbm8iou/XT2rsMwDIC7OqVSIK4GSe/ca19c2fc3c902ea7b8c597ea5d6b2310/x_dot_com_minified.svg"
        },
        {
          name: "YouTube",
          href: e("ig-legal-footer:YouTubeUrl"),
          imageUrl: "//images.ctfassets.net/7k5qhlbm8iou/aEg26dlG1YDNCGMkq1AY9/96226d1d9bc211f43d7cd16e78d0d5aa/youtube_dot_com_minified.svg"
        }
      ]
    };
  if (l.id === "gamma_be")
    return {
      legal: [
        {
          label: e("ig-legal-footer:PrivacyAndSecurity"),
          href: e("ig-legal-footer:PrivacyAndSecurityUrl")
        },
        {
          label: e("ig-legal-footer:Disclaimer"),
          href: e("ig-legal-footer:DisclaimerUrl")
        }
      ],
      partner: [],
      social: [
        {
          name: "Facebook",
          href: e("ig-legal-footer:FacebookUrl"),
          imageUrl: "//images.ctfassets.net/7k5qhlbm8iou/5CVpZOEfxbYwCrrnEXZUyp/60a1ed1b666a4f3244c863114be19745/facebook_minified.svg"
        },
        {
          name: "Instagram",
          href: e("ig-legal-footer:InstagramUrl"),
          imageUrl: "//images.ctfassets.net/7k5qhlbm8iou/lRrh2n73gAQnh8p16rJeO/69134dd5c63bf0ac606866d4c3789cb0/instagram_minified.svg"
        },
        {
          name: "Pinterest",
          href: e("ig-legal-footer:PinterestUrl"),
          imageUrl: "//images.ctfassets.net/7k5qhlbm8iou/3h09U8JGVyUaMI4BBqxuxA/677c038877b04cee83f805379adc137a/pinterest_dot_com_minified.svg"
        },
        {
          name: "YouTube",
          href: e("ig-legal-footer:YouTubeUrl"),
          imageUrl: "//images.ctfassets.net/7k5qhlbm8iou/aEg26dlG1YDNCGMkq1AY9/96226d1d9bc211f43d7cd16e78d0d5aa/youtube_dot_com_minified.svg"
        }
      ]
    };
  if (l.id === "karwei_nl")
    return {
      legal: [
        {
          label: e("ig-legal-footer:TermsAndConditions"),
          href: e("ig-legal-footer:TermsAndConditionsUrl")
        },
        {
          label: e("ig-legal-footer:PrivacyAndSecurity"),
          href: e("ig-legal-footer:PrivacyAndSecurityUrl")
        }
      ],
      partner: [],
      social: [
        {
          name: "Facebook",
          href: e("ig-legal-footer:FacebookUrl"),
          imageUrl: "//images.ctfassets.net/ufyps4xa8qu5/2ERovlsdfIRCb0fRCzfVFv/3571172085f38d8c589e1b213fa5336f/facebook_minified.svg"
        },
        {
          name: "YouTube",
          href: e("ig-legal-footer:YouTubeUrl"),
          imageUrl: "//images.ctfassets.net/ufyps4xa8qu5/6qYYL2bc1VhxsItVFFJ83K/6269089aa32fd976262d32f795ff6e56/youtube_dot_com_minified.svg"
        },
        {
          name: "Pinterest",
          href: e("ig-legal-footer:PinterestUrl"),
          imageUrl: "//images.ctfassets.net/ufyps4xa8qu5/6axTconxm37SHuOkw5uCrE/15ae10d312bff6553b813125ac0d4fdd/pinterest_dot_com_minified.svg"
        },
        {
          name: "Instagram",
          href: e("ig-legal-footer:InstagramUrl"),
          imageUrl: "//images.ctfassets.net/ufyps4xa8qu5/4nflPdNz1rA2hvQo34Jq4a/dcb32d5ef4495e6cb7fb00db7fa8f96a/instagram_karwei_minified.svg"
        }
      ]
    };
  throw Error(`No footer links found for formula "${l.id}"}`);
}
function u({
  formula: l,
  withAppPromotion: e,
  withSocials: o = !0,
  t: c,
  lang: s
}) {
  const t = C({ formula: l, t: c }), n = e ?? l.id === "gamma_be";
  return /* @__PURE__ */ a("div", { className: "bg-white py-6 font-light leading-6 text-brand-primary antialiased", children: /* @__PURE__ */ a(h, { children: /* @__PURE__ */ i("div", { className: "flex flex-col items-center gap-6 lg:flex-row", children: [
    /* @__PURE__ */ i("div", { className: "flex flex-1 flex-col items-center gap-4 text-[16px] leading-[24px] md:flex-row md:justify-start", children: [
      /* @__PURE__ */ a(
        d,
        {
          formula: l,
          href: c("ig-legal-footer:ShopfrontUrl")
        }
      ),
      /* @__PURE__ */ i("div", { className: "flex flex-col items-center gap-2 leading-normal md:flex-row md:justify-start", children: [
        /* @__PURE__ */ i("span", { children: [
          "© ",
          (/* @__PURE__ */ new Date()).getFullYear(),
          " Intergamma B.V."
        ] }),
        /* @__PURE__ */ a("div", { className: "hidden md:block", children: "-" }),
        t.legal.map((r, f) => /* @__PURE__ */ i(m, { children: [
          f > 0 ? /* @__PURE__ */ a("div", { className: "hidden md:block", children: "-" }) : null,
          /* @__PURE__ */ a(
            "a",
            {
              href: r.href,
              className: "no-underline underline-offset-2 hover:underline",
              children: r.label
            }
          )
        ] }, r.label))
      ] })
    ] }),
    /* @__PURE__ */ i("div", { className: "flex flex-row flex-nowrap items-center gap-6 leading-normal empty:contents md:flex-row md:justify-start", children: [
      t.partner.map((r) => /* @__PURE__ */ a("a", { href: r.href, children: /* @__PURE__ */ a(
        "img",
        {
          className: "h-6",
          src: r.imageUrl,
          alt: r.name,
          loading: "lazy"
        }
      ) }, r.name)),
      o && t.social.map((r) => /* @__PURE__ */ a("a", { href: r.href, children: /* @__PURE__ */ a(
        "img",
        {
          className: "h-6",
          src: r.imageUrl,
          alt: r.name,
          loading: "lazy"
        }
      ) }, r.name)),
      n && /* @__PURE__ */ a(g, { t: c, lang: s })
    ] })
  ] }) }) });
}
export {
  u as LegalFooter
};
